export default function PumpedStorageIcon() {
    return (
        <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 17.5899C14.0873 17.5899 17.4007 14.2724 17.4007 10.1799C17.4007 6.08748 14.0873 2.7699 10 2.7699C5.91272 2.7699 2.59932 6.08748 2.59932 10.1799C2.59932 14.2724 5.91272 17.5899 10 17.5899Z"
                fill="#678898"
            />
            <path
                d="M10.5392 4.53067C10.6379 4.55537 10.7436 4.57654 10.8388 4.61183C11.1313 4.71416 11.3357 4.93293 11.5048 5.19051C11.7938 5.62453 11.9418 6.11853 12.0581 6.62665C12.1885 7.20181 12.3083 7.78049 12.4387 8.35565C12.548 8.82848 12.6995 9.2872 13.0554 9.633C13.2951 9.86589 13.5382 10.0882 13.7814 10.3175C14.0633 10.5822 14.3594 10.8327 14.6237 11.1115C14.9444 11.4502 15.0959 11.8913 15.2263 12.3359C15.258 12.4488 15.2016 12.5476 15.0959 12.5829C15.0043 12.6147 14.9091 12.5688 14.8668 12.4594C14.814 12.3112 14.7682 12.1595 14.7153 12.0148C14.5779 11.6443 14.3558 11.3408 14.0633 11.0832C13.6862 10.748 13.3127 10.4058 12.9356 10.0705C12.5127 9.69299 12.2414 9.22368 12.118 8.65911C11.9911 8.08395 11.8643 7.50879 11.7374 6.93011C11.6352 6.45728 11.5189 5.9915 11.2828 5.56807C11.163 5.35283 11.0185 5.15523 10.8035 5.03526C10.7506 5.0035 10.6907 4.98233 10.6203 4.9541C10.6203 5.01056 10.6203 5.0529 10.6132 5.09171C10.5921 5.3246 10.3912 5.48339 10.1551 5.45869C9.94715 5.43752 9.77799 5.21522 9.80266 4.99644C9.82733 4.76356 9.95067 4.61536 10.1727 4.55537C10.1938 4.54831 10.2115 4.54126 10.2291 4.53067C10.3313 4.53067 10.4335 4.53067 10.5322 4.53067H10.5392Z"
                fill="#F5F6F6"
                stroke="#F9F9FA"
                strokeMiterlimit="10"
            />
            <path
                d="M9.04495 9.84117C8.37536 9.84117 7.7093 9.84117 7.03972 9.84117C6.96219 9.84117 6.88114 9.85176 6.80713 9.86588C6.5252 9.91528 6.36309 10.0952 6.33842 10.381C6.32784 10.5081 6.33842 10.6386 6.33842 10.7833L6.65207 10.7974V11.4149H4.75961V10.7974H5.06974C5.06974 10.494 5.05563 10.2011 5.07326 9.91528C5.08383 9.73885 5.11555 9.55536 5.18603 9.39657C5.38691 8.93786 5.78865 8.72967 6.25031 8.63793C6.48995 8.58853 6.74017 8.57089 6.98334 8.56736C7.65645 8.55677 8.32955 8.56736 9.00266 8.56736"
                fill="#F5F6F6"
            />
            <path
                d="M11.3004 7.58289H8.82645V15.8327H11.3004V7.58289Z"
                fill="#F5F6F6"
            />
            <path
                d="M5.7358 11.8348C5.97897 12.2195 6.22214 12.5864 6.37015 13.0063C6.48997 13.3486 6.26794 13.7509 5.89086 13.8391C5.5173 13.9273 5.14375 13.6803 5.07679 13.3098C5.05917 13.2039 5.06622 13.1051 5.10146 13.0028C5.24595 12.5829 5.49263 12.2159 5.7358 11.8348Z"
                fill="#F5F6F6"
            />
            <path
                d="M10.3453 6.04089H9.7533V9.2272H10.3453V6.04089Z"
                fill="#F5F6F6"
            />
        </svg>
    );
}
